/**
 * 验证相关工具函数
 */

/**
 * 验证邮箱格式
 * @param {String} email - 邮箱地址
 * @returns {Boolean} 验证结果
 */
export function validateEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return re.test(email)
}

/**
 * 验证URL格式
 * @param {String} url - URL地址
 * @returns {Boolean} 验证结果
 */
export function validateURL(url) {
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}

/**
 * 验证手机号格式
 * @param {String} phone - 手机号
 * @returns {Boolean} 验证结果
 */
export function validatePhone(phone) {
  const re = /^1[3-9]\d{9}$/
  return re.test(phone)
}

/**
 * 验证身份证号格式
 * @param {String} idCard - 身份证号
 * @returns {Boolean} 验证结果
 */
export function validateIdCard(idCard) {
  const re = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return re.test(idCard)
}

/**
 * 验证密码强度
 * @param {String} password - 密码
 * @param {Object} options - 选项
 * @returns {Object} 验证结果
 */
export function validatePassword(password, options = {}) {
  const {
    minLength = 8,
    requireUppercase = true,
    requireLowercase = true,
    requireNumbers = true,
    requireSpecialChars = false
  } = options
  
  const result = {
    isValid: true,
    errors: []
  }
  
  if (password.length < minLength) {
    result.isValid = false
    result.errors.push(`密码长度不能少于${minLength}位`)
  }
  
  if (requireUppercase && !/[A-Z]/.test(password)) {
    result.isValid = false
    result.errors.push('密码必须包含大写字母')
  }
  
  if (requireLowercase && !/[a-z]/.test(password)) {
    result.isValid = false
    result.errors.push('密码必须包含小写字母')
  }
  
  if (requireNumbers && !/\d/.test(password)) {
    result.isValid = false
    result.errors.push('密码必须包含数字')
  }
  
  if (requireSpecialChars && !/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    result.isValid = false
    result.errors.push('密码必须包含特殊字符')
  }
  
  return result
}

/**
 * 验证表单数据
 * @param {Object} data - 表单数据
 * @param {Object} rules - 验证规则
 * @returns {Object} 验证结果
 */
export function validateForm(data, rules) {
  const result = {
    isValid: true,
    errors: {}
  }
  
  for (const [field, fieldRules] of Object.entries(rules)) {
    const value = data[field]
    const fieldErrors = []
    
    for (const rule of fieldRules) {
      if (rule.required && (value === undefined || value === null || value === '')) {
        fieldErrors.push(rule.message || `${field}是必填项`)
        continue
      }
      
      if (value !== undefined && value !== null && value !== '') {
        if (rule.type && typeof value !== rule.type) {
          fieldErrors.push(rule.message || `${field}类型不正确`)
          continue
        }
        
        if (rule.min && value.length < rule.min) {
          fieldErrors.push(rule.message || `${field}长度不能少于${rule.min}`)
          continue
        }
        
        if (rule.max && value.length > rule.max) {
          fieldErrors.push(rule.message || `${field}长度不能超过${rule.max}`)
          continue
        }
        
        if (rule.pattern && !rule.pattern.test(value)) {
          fieldErrors.push(rule.message || `${field}格式不正确`)
          continue
        }
        
        if (rule.validator && !rule.validator(value)) {
          fieldErrors.push(rule.message || `${field}验证失败`)
          continue
        }
      }
    }
    
    if (fieldErrors.length > 0) {
      result.isValid = false
      result.errors[field] = fieldErrors
    }
  }
  
  return result
}
